<template>
  <div v-if="object.id">
    <MentionTextArea v-model="comment"
                     :labelclass="blackLabel ? 'black' : ''"
                     :label="$t('leave_comment')"/>
    <div class="text-right">
      <button class="btn-themed btn-themed-squared"
              @click="saveComment"
              :disabled="loading || !comment.length">
        {{ $t('send') }}
      </button>
    </div>
    <slot/>
    <div class="mt-md-2 mt-3">
      <div v-for="c in comments"
           :key="`comment-${c.id}`"
           class="comment">
        <div>
          <span class="comment-author text-primary mr-2" v-if="c.author">
            {{ c.author ? c.author.full_name : '' }}
          </span>
          <span class="comment-date text-muted">
            {{ formatDateTime(c.created_at) }}
          </span>
        </div>
        <div class="comment-block"
             v-dompurify-html="processTextForLinks(c.text)"></div>
      </div>
      <div v-if="hasMore">
        <b-button class="btn btn-themed btn-themed-squared btn-themed-outline"
                  :disabled="loadingMore"
                  variant="themed"
                  @click="loadMore">
          {{ $t('load_more') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import MentionTextArea from "@/components/form/MentionTextArea"
import { EloquentService } from "@/services/api/eloquent.api.service"
import { formatDateTime } from "@/extensions/filters/filters"
import { processTextForLinks } from "@/services/text.service"
import { appendFormdata } from "@/extensions/prototypes/prototypes"
import { computed, onMounted, ref } from "vue"
import { useStore } from "vuex"

const props = defineProps({
  model: String,
  parentColumn: String,
  object: {},
  blackLabel: {
    type: Boolean,
    default: true
  }
})

const store = useStore()

const comment = ref('')
// newest first
const comments = ref([])
const page = ref(1)
const hasMore = ref(false)
const loadingMore = ref(false)

const loading = computed(() => store.state.dom.loading)

// the saved comment is shown on top, as the server returns it
const saveComment = async () => {
  if(!comment.value) return
  if(!props.object.id) return
  let formData = new FormData()
  formData = appendFormdata(formData, {
    [props.parentColumn]: props.object.id,
    text: comment.value
  })
  const commentRes = await EloquentService.create(props.model, formData)
  comment.value = ''
  const newComment = await EloquentService.show(props.model, commentRes.data.id)
  // comments.value.push(newComment.data)
  comments.value.unshift(newComment.data)
}

const getComments = async () => {
  if(!props.object.id) return
  const res = await EloquentService.dataTable(props.model, page.value, {
    sort: 'desc',
    order: 'id',
    condition: {
      [props.parentColumn]: props.object.id
    },
  })
  const data = res.data.result
  comments.value = comments.value.concat(data.data)
  hasMore.value = data.last_page > data.current_page
}

const loadMore = async () => {
  if(loadingMore.value) return
  loadingMore.value = true
  page.value++
  await getComments()
  loadingMore.value = false
}

onMounted(() => {
  getComments()
})
</script>

<style scoped lang="scss">
.comment-block {
  background: #F8FAFC;
  padding: 9px 13px;
  white-space: pre-wrap;
  word-break: break-word;
}
.comment {
  //font-size:  14px;
  margin-bottom: 15px;
  &-author {
    font-size: 15px;
  }
  &-date {
    font-size: 14px;
  }
}
@media screen and (max-width: 768px) {
  .comment {
    &-author {
      font-size: 13px;
    }
    &-date {
      font-size: 12px;
    }
  }
}
</style>
